<script lang="ts" setup>
import { useAppStore } from '@/stores/appStore'
import OnboardingView from '@/views/onboardingView.vue'
import { ref } from 'vue'

const appStore = useAppStore()
const { calendarDelivery } = defineProps<{ calendarDelivery: boolean | null }>()
const calendars = appStore.calendars
const dialog = ref(false)
</script>

<template>
  <div class="myCard q-pa-md full-height">
    <h5 class="text-h5 q-mb-md">Connected Calendars</h5>
    <div class="row justify-between">
      <div>
        <div v-for="calendar in calendars" :key="calendar.calendarID">
          <div class="row items-center">
            <div class="col-12 col-md-10">
              <div class="text caption">{{ calendar.summary }}</div>
              <q-icon color="warning" v-if="calendarDelivery && calendar.readOnly" name="mdi-alert">
                <q-tooltip>Calendar is read only. Cannot deliver information via calendar.</q-tooltip>
              </q-icon>
            </div>
          </div>
        </div>
      </div>
      <q-btn color="secondary" label="Modify" @click="dialog = true" />
    </div>
  </div>

  <q-dialog v-model="dialog">
    <OnboardingView :nextFn="() => (dialog = false)" @next="dialog = false" />
  </q-dialog>
</template>
